import { CustomButton, YellowButton } from '../../utils/Button';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useSendOTP } from '../../hooks/useSendOTP';
import { requestPasswordResetOTP } from '../../api/authAPI';
import { useState } from 'react';

const ForgotPassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(900);

  const { mutate: requestPasswordResetMutation, isPending } = useSendOTP(
    requestPasswordResetOTP,
    (email) => {
      setTimeLeft(900);
      navigate(`/reset-password/${encodeURIComponent(email)}`);
    }
  );

  const onSubmit = (data) => {
    requestPasswordResetMutation(data);
  };

  return (
    <>
      <div className="flex-1 py-6 px-5 flex flex-col items-start  lg:pl-36">
        <div className="w-full">
          <div className=" flex justify-center mb-10 lg:mb-5 text-center w-full  lg:justify-end lg:pr-8">
            <Link to="/" aria-label="Fair Home">
              <img
                src="/images/SST_LOGO_HORIZONTAL_WEB_DARK.svg"
                alt="SmallSmall Logo"
                width={120}
                height={40}
                loading="eager"
                decoding="defer"
              />
            </Link>
          </div>
        </div>
      </div>
      <section className="px-5 md:w-[480px] mx-auto grid gap-3">
        <h1 className="font-semibold text-[29px] font-duplet">
          Reset password
        </h1>
        <p className="font-normal text-base md:w-[415px] ">
          Enter your email address and we will send you instructions to reset
          your password.
        </p>
        <form action="submit" onSubmit={handleSubmit(onSubmit)}>
          <div className="space-y-2 mb-5">
            <label htmlFor="email" className="text-sm font-medium sr-only">
              Email address
            </label>
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full p-2 border border-[#DBDBDB] rounded-[6px]"
              {...register('email', {
                required: 'Email is required',
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: 'Invalid email address',
                },
              })}
            />
            {errors.email && (
              <p className="text-sm text-red-500 mt-1">
                {errors.email.message}
              </p>
            )}
          </div>

          <CustomButton
            text={isPending ? 'Sending OTP' : 'Continue'}
            disabled={isPending}
            borderRadius="20px"
            width="100%"
            onClick={handleSubmit(onSubmit)}
          />
          <Link to="/" className="mt-3 flex justify-center font-semibold">
            Back to SmallSmall
          </Link>
        </form>
      </section>
    </>
  );
};

export default ForgotPassword;
